<div class="card-header">
  <div class="grid-x">
    <div class="cell auto">
      <h4 [id]="'WIDGET_'.concat(widgetSize)">{{widgetLabel}}</h4>
    </div>
  </div>
</div>
<div class="card-body"
     style="display: flex; justify-content: center; align-items: center;"
      [ngStyle]="widgetSize === widgetsSize.XLARGE && {'min-height.px': 319}">
  <div class="icone-placeholder">
    <span class="opt {{icone}}"></span>
  </div>
  <div class="padding-v-xl margin-v" style="text-align:center;">
    <span class="label-mao-small c-dark-gray">{{message}}</span>
  </div>
</div>
<div class="card-footer">
  <div *ngIf="callToActionHref && callToActionButtonLabel" class="text-center">
    <a (click)="actionEvent.emit(actionLabel)"
       [href]="callToActionHref"
       class="button insito">
    <span
      [title]="callToActionButtonLabel">
      {{callToActionButtonLabel}}</span>
    </a>
  </div>
</div>
